export const ADDRESS_STATUS = {
  missing: ['Missing', 'bg-[#FFE4EC] text-[#B4235A] border-[#F8C3D3]'],
  needs_fix: ['Needs fix', 'bg-[#FFF8E1] text-[#B45309] border-[#FCE3A6]'],
  requested: ['Requested', 'bg-[#E0F2FE] text-[#0369A1] border-[#BAE6FD]'],
  received: ['Received', 'bg-[#E8F5E9] text-[#2E7D32] border-[#C8E6C9]'],
  ok: ['On file', 'bg-[#F1F5F9] text-[#475569] border-[#E2E8F0]'],
};

export const addressStatus = (g) => {
  const st = g.address_status || 'missing';
  const req = g.address_request?.status;
  if (st === 'needs_fix') return 'needs_fix';
  if (req === 'received' || (st === 'ok' && req)) return 'received';
  if (req === 'requested') return 'requested';
  return st === 'ok' ? 'ok' : 'missing';
};

export const MEAL_PRESETS = ['Meat', 'Fish', 'Vegetarian', 'Vegan', 'Kids'];
